/* Bhairav Tatva v11 — sticky product gallery offset (desktop).
   Below the header when Horizon's scroll-up header is showing; and when the gallery is taller than the
   screen, it sticks by its bottom edge so the thumbnails are never cut off. */
(() => {
  const mq = matchMedia('(min-width: 750px)');
  const GAP = 24;
  let raf = 0;
  const update = () => {
    raf = 0;
    const wrap = document.querySelector('.product-information__media > .bt-gal-wrap');
    if (!wrap) return;
    if (!mq.matches) { wrap.style.removeProperty('--bt-gal-top'); return; }
    const header = document.querySelector('#header-component');
    const shown = header && header.dataset.stickyState === 'active';
    const headerH = shown ? header.getBoundingClientRect().height : 0;
    const scroller = document.querySelector('.page-wrapper');
    const viewH = scroller && scroller.scrollHeight > scroller.clientHeight ? scroller.clientHeight : window.innerHeight;
    let top = headerH + GAP;
    const h = wrap.getBoundingClientRect().height;
    if (h + top + GAP > viewH) top = Math.min(top, viewH - h - GAP);
    wrap.style.setProperty('--bt-gal-top', `${Math.round(top)}px`);
  };
  const queue = () => { if (!raf) raf = requestAnimationFrame(update); };
  const start = () => {
    update();
    const header = document.querySelector('#header-component');
    if (header) new MutationObserver(queue).observe(header, { attributes: true, attributeFilter: ['data-sticky-state'] });
    const wrap = document.querySelector('.product-information__media > .bt-gal-wrap');
    if (wrap && 'ResizeObserver' in window) new ResizeObserver(queue).observe(wrap);
    window.addEventListener('resize', queue);
    mq.addEventListener('change', queue);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
